import { useMutation, useQuery, useInfiniteQuery, UseMutationOptions, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };

function fetcher<TData, TVariables>(endpoint: string, requestInit: RequestInit, query: string, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(endpoint, {
      method: 'POST',
      ...requestInit,
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
  JSON: { input: Record<string, any>; output: Record<string, any>; }
};

export type AddCommentInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  itemId: Scalars['ID']['input'];
};

export type AddCommentPayload = {
  __typename?: 'AddCommentPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  comment: Comment;
  feedItem: FeedItem;
};

export type Author = Node & {
  __typename?: 'Author';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  followerCount: Scalars['Int']['output'];
  followingCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isVerified: Scalars['Boolean']['output'];
  username: Scalars['String']['output'];
};

export type Comment = Node & {
  __typename?: 'Comment';
  author: Author;
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  likes: Scalars['Int']['output'];
};

export enum ContentType {
  Image = 'IMAGE',
  Link = 'LINK',
  Poll = 'POLL',
  Text = 'TEXT',
  Thread = 'THREAD',
  Video = 'VIDEO'
}

export type CreatePostInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  contentType?: InputMaybe<ContentType>;
  hashtags?: InputMaybe<Array<Scalars['String']['input']>>;
  mediaUrls?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreatePostPayload = {
  __typename?: 'CreatePostPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  feedEdge: FeedEdge;
  feedItem: FeedItem;
};

export type CreateTweetInput = {
  body: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  hashtags: Array<Scalars['String']['input']>;
  isSensitive?: InputMaybe<Scalars['Boolean']['input']>;
  mediaUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  mentions: Array<Scalars['String']['input']>;
  poll?: InputMaybe<PollInput>;
  quoteTweetId?: InputMaybe<Scalars['ID']['input']>;
  replyToId?: InputMaybe<Scalars['ID']['input']>;
  visibility?: InputMaybe<TweetVisibility>;
};

export type CreateTweetPayload = {
  __typename?: 'CreateTweetPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  tweet: Tweet;
  tweetEdge: TweetEdge;
};

export type CreateTweetWithMediaInput = {
  body: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  hashtags: Array<Scalars['String']['input']>;
  isSensitive?: InputMaybe<Scalars['Boolean']['input']>;
  mediaUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  mentions: Array<Scalars['String']['input']>;
  poll?: InputMaybe<PollInput>;
  quoteTweetId?: InputMaybe<Scalars['ID']['input']>;
  replyToId?: InputMaybe<Scalars['ID']['input']>;
  visibility?: InputMaybe<TweetVisibility>;
};

export type DeletePostInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['ID']['input'];
};

export type DeletePostPayload = {
  __typename?: 'DeletePostPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedItemId: Scalars['ID']['output'];
};

export type DeleteTweetInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  tweetId: Scalars['ID']['input'];
};

export type DeleteTweetPayload = {
  __typename?: 'DeleteTweetPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedTweetId: Scalars['ID']['output'];
};

export type Engagement = {
  __typename?: 'Engagement';
  comments: Scalars['Int']['output'];
  likes: Scalars['Int']['output'];
  quotes: Scalars['Int']['output'];
  replies: Scalars['Int']['output'];
  retweets: Scalars['Int']['output'];
  shares: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  views: Scalars['Int']['output'];
};

export type FeedConnection = {
  __typename?: 'FeedConnection';
  edges: Array<FeedEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type FeedEdge = {
  __typename?: 'FeedEdge';
  cursor: Scalars['String']['output'];
  node: FeedItem;
};

export type FeedItem = Node & {
  __typename?: 'FeedItem';
  author?: Maybe<Author>;
  authorId: Scalars['ID']['output'];
  category?: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  contentType: ContentType;
  createdAt: Scalars['DateTime']['output'];
  engagement: Engagement;
  hashtags?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  mediaUrls: Array<Scalars['String']['output']>;
  status: FeedStatus;
  updatedAt: Scalars['DateTime']['output'];
  viewerCanDelete: Scalars['Boolean']['output'];
  viewerCanEdit: Scalars['Boolean']['output'];
  viewerHasLiked: Scalars['Boolean']['output'];
  viewerHasShared: Scalars['Boolean']['output'];
};

export enum FeedStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Flagged = 'FLAGGED',
  Hidden = 'HIDDEN'
}

export enum FeedType {
  Custom = 'CUSTOM',
  Following = 'FOLLOWING',
  ForYou = 'FOR_YOU',
  Trending = 'TRENDING'
}

export type Mutation = {
  __typename?: 'Mutation';
  addComment: AddCommentPayload;
  createPost: CreatePostPayload;
  createTweet: CreateTweetPayload;
  createTweetWithMedia: CreateTweetPayload;
  deletePost: DeletePostPayload;
  deleteTweet: DeleteTweetPayload;
  sharePost: SharePostPayload;
  toggleLike: ToggleLikePayload;
  updateFeedSettings: UpdateFeedSettingsPayload;
  updateTweet: UpdateTweetPayload;
};


export type MutationAddCommentArgs = {
  input: AddCommentInput;
};


export type MutationCreatePostArgs = {
  input: CreatePostInput;
};


export type MutationCreateTweetArgs = {
  input: CreateTweetInput;
};


export type MutationCreateTweetWithMediaArgs = {
  input: CreateTweetWithMediaInput;
};


export type MutationDeletePostArgs = {
  input: DeletePostInput;
};


export type MutationDeleteTweetArgs = {
  input: DeleteTweetInput;
};


export type MutationSharePostArgs = {
  input: SharePostInput;
};


export type MutationToggleLikeArgs = {
  input: ToggleLikeInput;
};


export type MutationUpdateFeedSettingsArgs = {
  input: UpdateFeedSettingsInput;
};


export type MutationUpdateTweetArgs = {
  input: UpdateTweetInput;
};

export type Node = {
  id: Scalars['ID']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Poll = {
  __typename?: 'Poll';
  durationMinutes: Scalars['Int']['output'];
  endsAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  options: Array<PollOption>;
  totalVotes: Scalars['Int']['output'];
};

export type PollInput = {
  durationMinutes: Scalars['Int']['input'];
  options: Array<PollOptionInput>;
};

export type PollOption = {
  __typename?: 'PollOption';
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
  votes: Scalars['Int']['output'];
};

export type PollOptionInput = {
  text: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  feedItem?: Maybe<FeedItem>;
  followingFeed: FeedConnection;
  forYouFeed: FeedConnection;
  node?: Maybe<Node>;
  replies: FeedConnection;
  trendingFeed: FeedConnection;
  tweet?: Maybe<Tweet>;
  userFeedSettings?: Maybe<UserFeedSettings>;
  userTweets: TweetConnection;
};


export type QueryFeedItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFollowingFeedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  followingIds: Array<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};


export type QueryForYouFeedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRepliesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  parentId: Scalars['ID']['input'];
};


export type QueryTrendingFeedArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  timeRange?: InputMaybe<TimeRange>;
};


export type QueryTweetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserFeedSettingsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryUserTweetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['ID']['input'];
};

export type SharePostInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['ID']['input'];
};

export type SharePostPayload = {
  __typename?: 'SharePostPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  feedItem: FeedItem;
  sharedPost: FeedItem;
};

export type Subscription = {
  __typename?: 'Subscription';
  onCommentAdded: Comment;
  onLikeUpdate: FeedItem;
  onNewPost: FeedItem;
};


export type SubscriptionOnCommentAddedArgs = {
  itemId: Scalars['ID']['input'];
};


export type SubscriptionOnLikeUpdateArgs = {
  itemId: Scalars['ID']['input'];
};


export type SubscriptionOnNewPostArgs = {
  followingIds: Array<Scalars['ID']['input']>;
};

export enum TimeRange {
  Last_24Hours = 'LAST_24_HOURS',
  LastHour = 'LAST_HOUR',
  LastMonth = 'LAST_MONTH',
  LastWeek = 'LAST_WEEK'
}

export type ToggleLikeInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  isLike: Scalars['Boolean']['input'];
  itemId: Scalars['ID']['input'];
};

export type ToggleLikePayload = {
  __typename?: 'ToggleLikePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  feedItem: FeedItem;
};

export type Tweet = Node & {
  __typename?: 'Tweet';
  authorId: Scalars['ID']['output'];
  authorName: Scalars['String']['output'];
  authorProfileImageUrl?: Maybe<Scalars['String']['output']>;
  authorUsername: Scalars['String']['output'];
  body: Scalars['String']['output'];
  bookmarkCount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  editedBody?: Maybe<Scalars['String']['output']>;
  hashtags: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isEdited: Scalars['Boolean']['output'];
  isPinned: Scalars['Boolean']['output'];
  isRetweet: Scalars['Boolean']['output'];
  isSensitive: Scalars['Boolean']['output'];
  likeCount: Scalars['Int']['output'];
  mediaUrls: Array<Scalars['String']['output']>;
  mentions: Array<Scalars['String']['output']>;
  originalTweetId?: Maybe<Scalars['ID']['output']>;
  poll?: Maybe<Poll>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  quoteCount: Scalars['Int']['output'];
  quoteTweetId?: Maybe<Scalars['ID']['output']>;
  replyCount: Scalars['Int']['output'];
  replyToId?: Maybe<Scalars['ID']['output']>;
  retweetCount: Scalars['Int']['output'];
  status: TweetStatus;
  updatedAt: Scalars['DateTime']['output'];
  viewCount: Scalars['Int']['output'];
  visibility: TweetVisibility;
};

export type TweetConnection = {
  __typename?: 'TweetConnection';
  edges: Array<TweetEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TweetEdge = {
  __typename?: 'TweetEdge';
  cursor: Scalars['String']['output'];
  node: Tweet;
};

export enum TweetStatus {
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  Flagged = 'FLAGGED',
  Hidden = 'HIDDEN',
  Published = 'PUBLISHED',
  Scheduled = 'SCHEDULED'
}

export enum TweetVisibility {
  Circle = 'CIRCLE',
  FollowersOnly = 'FOLLOWERS_ONLY',
  MentionedOnly = 'MENTIONED_ONLY',
  Public = 'PUBLIC'
}

export type UpdateFeedSettingsInput = {
  blockedAuthors?: InputMaybe<Array<Scalars['ID']['input']>>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  mutedKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateFeedSettingsPayload = {
  __typename?: 'UpdateFeedSettingsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  settings: UserFeedSettings;
};

export type UpdateTweetInput = {
  body: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  isSensitive?: InputMaybe<Scalars['Boolean']['input']>;
  tweetId: Scalars['ID']['input'];
};

export type UpdateTweetPayload = {
  __typename?: 'UpdateTweetPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  tweet: Tweet;
};

export type UserFeedSettings = Node & {
  __typename?: 'UserFeedSettings';
  blockedAuthors: Array<Scalars['ID']['output']>;
  feedType: FeedType;
  id: Scalars['ID']['output'];
  interests: Array<Scalars['String']['output']>;
  mutedKeywords: Array<Scalars['String']['output']>;
  preferences: Scalars['JSON']['output'];
  userId: Scalars['ID']['output'];
};

export type CreateTweetMutationVariables = Exact<{
  input: CreateTweetInput;
}>;


export type CreateTweetMutation = { __typename?: 'Mutation', createTweet: { __typename?: 'CreateTweetPayload', clientMutationId?: string | null, tweet: { __typename?: 'Tweet', id: string, authorId: string, authorName: string, authorUsername: string, authorProfileImageUrl?: string | null, body: string, mediaUrls: Array<string>, hashtags: Array<string>, mentions: Array<string>, visibility: TweetVisibility, status: TweetStatus, createdAt: string, updatedAt: string, likeCount: number, retweetCount: number, replyCount: number, viewCount: number }, tweetEdge: { __typename?: 'TweetEdge', cursor: string, node: { __typename?: 'Tweet', id: string, body: string } } } };

export type CreateTweetWithMediaMutationVariables = Exact<{
  input: CreateTweetWithMediaInput;
}>;


export type CreateTweetWithMediaMutation = { __typename?: 'Mutation', createTweetWithMedia: { __typename?: 'CreateTweetPayload', clientMutationId?: string | null, tweet: { __typename?: 'Tweet', id: string, authorId: string, authorName: string, authorUsername: string, authorProfileImageUrl?: string | null, body: string, mediaUrls: Array<string>, hashtags: Array<string>, mentions: Array<string>, visibility: TweetVisibility, status: TweetStatus, createdAt: string, updatedAt: string, likeCount: number, retweetCount: number, replyCount: number, viewCount: number }, tweetEdge: { __typename?: 'TweetEdge', cursor: string, node: { __typename?: 'Tweet', id: string, body: string } } } };

export type UpdateTweetMutationVariables = Exact<{
  input: UpdateTweetInput;
}>;


export type UpdateTweetMutation = { __typename?: 'Mutation', updateTweet: { __typename?: 'UpdateTweetPayload', clientMutationId?: string | null, tweet: { __typename?: 'Tweet', id: string, body: string, editedBody?: string | null, isEdited: boolean, updatedAt: string } } };

export type DeleteTweetMutationVariables = Exact<{
  input: DeleteTweetInput;
}>;


export type DeleteTweetMutation = { __typename?: 'Mutation', deleteTweet: { __typename?: 'DeleteTweetPayload', deletedTweetId: string, clientMutationId?: string | null } };

export type GetForYouFeedQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']['input']>;
  interests?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetForYouFeedQuery = { __typename?: 'Query', forYouFeed: { __typename?: 'FeedConnection', totalCount?: number | null, edges: Array<{ __typename?: 'FeedEdge', cursor: string, node: { __typename?: 'FeedItem', id: string, content: string, contentType: ContentType, mediaUrls: Array<string>, category?: string | null, hashtags?: Array<string> | null, createdAt: string, viewerHasLiked: boolean, viewerHasShared: boolean, author?: { __typename?: 'Author', id: string, username: string, displayName: string, avatarUrl?: string | null, isVerified: boolean } | null, engagement: { __typename?: 'Engagement', likes: number, comments: number, shares: number, views: number } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type GetFollowingFeedQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  followingIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetFollowingFeedQuery = { __typename?: 'Query', followingFeed: { __typename?: 'FeedConnection', edges: Array<{ __typename?: 'FeedEdge', node: { __typename?: 'FeedItem', id: string, content: string, author?: { __typename?: 'Author', id: string, username: string, displayName: string, avatarUrl?: string | null } | null, engagement: { __typename?: 'Engagement', likes: number, comments: number } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type GetUserTweetsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUserTweetsQuery = { __typename?: 'Query', userTweets: { __typename?: 'TweetConnection', totalCount?: number | null, edges: Array<{ __typename?: 'TweetEdge', cursor: string, node: { __typename?: 'Tweet', id: string, body: string, mediaUrls: Array<string>, hashtags: Array<string>, mentions: Array<string>, createdAt: string, updatedAt: string, authorId: string, authorName: string, authorUsername: string, authorProfileImageUrl?: string | null, isRetweet: boolean, visibility: TweetVisibility, status: TweetStatus } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type GetFeedItemQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetFeedItemQuery = { __typename?: 'Query', feedItem?: { __typename?: 'FeedItem', id: string, content: string, contentType: ContentType, mediaUrls: Array<string>, category?: string | null, hashtags?: Array<string> | null, createdAt: string, updatedAt: string, viewerHasLiked: boolean, viewerHasShared: boolean, viewerCanEdit: boolean, viewerCanDelete: boolean, author?: { __typename?: 'Author', id: string, username: string, displayName: string, avatarUrl?: string | null, isVerified: boolean } | null, engagement: { __typename?: 'Engagement', likes: number, comments: number, shares: number, views: number, retweets: number, replies: number, quotes: number } } | null };

export type GetRepliesQueryVariables = Exact<{
  parentId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetRepliesQuery = { __typename?: 'Query', replies: { __typename?: 'FeedConnection', totalCount?: number | null, edges: Array<{ __typename?: 'FeedEdge', cursor: string, node: { __typename?: 'FeedItem', id: string, content: string, contentType: ContentType, mediaUrls: Array<string>, hashtags?: Array<string> | null, createdAt: string, updatedAt: string, viewerHasLiked: boolean, viewerHasShared: boolean, author?: { __typename?: 'Author', id: string, username: string, displayName: string, avatarUrl?: string | null, isVerified: boolean } | null, engagement: { __typename?: 'Engagement', likes: number, comments: number, shares: number, views: number } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type CreatePostMutationVariables = Exact<{
  input: CreatePostInput;
}>;


export type CreatePostMutation = { __typename?: 'Mutation', createPost: { __typename?: 'CreatePostPayload', clientMutationId?: string | null, feedItem: { __typename?: 'FeedItem', id: string, content: string, author?: { __typename?: 'Author', id: string, username: string } | null }, feedEdge: { __typename?: 'FeedEdge', cursor: string, node: { __typename?: 'FeedItem', id: string } } } };

export type ToggleLikeMutationVariables = Exact<{
  input: ToggleLikeInput;
}>;


export type ToggleLikeMutation = { __typename?: 'Mutation', toggleLike: { __typename?: 'ToggleLikePayload', clientMutationId?: string | null, feedItem: { __typename?: 'FeedItem', id: string, viewerHasLiked: boolean, engagement: { __typename?: 'Engagement', likes: number } } } };

export type AddCommentMutationVariables = Exact<{
  input: AddCommentInput;
}>;


export type AddCommentMutation = { __typename?: 'Mutation', addComment: { __typename?: 'AddCommentPayload', clientMutationId?: string | null, feedItem: { __typename?: 'FeedItem', id: string, engagement: { __typename?: 'Engagement', comments: number } }, comment: { __typename?: 'Comment', id: string, content: string, createdAt: string, author: { __typename?: 'Author', id: string, username: string, displayName: string, avatarUrl?: string | null } } } };

export type SharePostMutationVariables = Exact<{
  input: SharePostInput;
}>;


export type SharePostMutation = { __typename?: 'Mutation', sharePost: { __typename?: 'SharePostPayload', clientMutationId?: string | null, feedItem: { __typename?: 'FeedItem', id: string, engagement: { __typename?: 'Engagement', shares: number } }, sharedPost: { __typename?: 'FeedItem', id: string, content: string, author?: { __typename?: 'Author', username: string } | null } } };



export const CreateTweetDocument = /*#__PURE__*/ `
    mutation CreateTweet($input: CreateTweetInput!) {
  createTweet(input: $input) {
    tweet {
      id
      authorId
      authorName
      authorUsername
      authorProfileImageUrl
      body
      mediaUrls
      hashtags
      mentions
      visibility
      status
      createdAt
      updatedAt
      likeCount
      retweetCount
      replyCount
      viewCount
    }
    tweetEdge {
      node {
        id
        body
      }
      cursor
    }
    clientMutationId
  }
}
    `;

export const useCreateTweetMutation = <
      TError = unknown,
      TContext = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      options?: UseMutationOptions<CreateTweetMutation, TError, CreateTweetMutationVariables, TContext>
    ) => {
    
    return useMutation<CreateTweetMutation, TError, CreateTweetMutationVariables, TContext>(
      {
    mutationKey: ['CreateTweet'],
    mutationFn: (variables?: CreateTweetMutationVariables) => fetcher<CreateTweetMutation, CreateTweetMutationVariables>(dataSource.endpoint, dataSource.fetchParams || {}, CreateTweetDocument, variables)(),
    ...options
  }
    )};

useCreateTweetMutation.getKey = () => ['CreateTweet'];

export const CreateTweetWithMediaDocument = /*#__PURE__*/ `
    mutation CreateTweetWithMedia($input: CreateTweetWithMediaInput!) {
  createTweetWithMedia(input: $input) {
    tweet {
      id
      authorId
      authorName
      authorUsername
      authorProfileImageUrl
      body
      mediaUrls
      hashtags
      mentions
      visibility
      status
      createdAt
      updatedAt
      likeCount
      retweetCount
      replyCount
      viewCount
    }
    tweetEdge {
      node {
        id
        body
      }
      cursor
    }
    clientMutationId
  }
}
    `;

export const useCreateTweetWithMediaMutation = <
      TError = unknown,
      TContext = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      options?: UseMutationOptions<CreateTweetWithMediaMutation, TError, CreateTweetWithMediaMutationVariables, TContext>
    ) => {
    
    return useMutation<CreateTweetWithMediaMutation, TError, CreateTweetWithMediaMutationVariables, TContext>(
      {
    mutationKey: ['CreateTweetWithMedia'],
    mutationFn: (variables?: CreateTweetWithMediaMutationVariables) => fetcher<CreateTweetWithMediaMutation, CreateTweetWithMediaMutationVariables>(dataSource.endpoint, dataSource.fetchParams || {}, CreateTweetWithMediaDocument, variables)(),
    ...options
  }
    )};

useCreateTweetWithMediaMutation.getKey = () => ['CreateTweetWithMedia'];

export const UpdateTweetDocument = /*#__PURE__*/ `
    mutation UpdateTweet($input: UpdateTweetInput!) {
  updateTweet(input: $input) {
    tweet {
      id
      body
      editedBody
      isEdited
      updatedAt
    }
    clientMutationId
  }
}
    `;

export const useUpdateTweetMutation = <
      TError = unknown,
      TContext = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      options?: UseMutationOptions<UpdateTweetMutation, TError, UpdateTweetMutationVariables, TContext>
    ) => {
    
    return useMutation<UpdateTweetMutation, TError, UpdateTweetMutationVariables, TContext>(
      {
    mutationKey: ['UpdateTweet'],
    mutationFn: (variables?: UpdateTweetMutationVariables) => fetcher<UpdateTweetMutation, UpdateTweetMutationVariables>(dataSource.endpoint, dataSource.fetchParams || {}, UpdateTweetDocument, variables)(),
    ...options
  }
    )};

useUpdateTweetMutation.getKey = () => ['UpdateTweet'];

export const DeleteTweetDocument = /*#__PURE__*/ `
    mutation DeleteTweet($input: DeleteTweetInput!) {
  deleteTweet(input: $input) {
    deletedTweetId
    clientMutationId
  }
}
    `;

export const useDeleteTweetMutation = <
      TError = unknown,
      TContext = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      options?: UseMutationOptions<DeleteTweetMutation, TError, DeleteTweetMutationVariables, TContext>
    ) => {
    
    return useMutation<DeleteTweetMutation, TError, DeleteTweetMutationVariables, TContext>(
      {
    mutationKey: ['DeleteTweet'],
    mutationFn: (variables?: DeleteTweetMutationVariables) => fetcher<DeleteTweetMutation, DeleteTweetMutationVariables>(dataSource.endpoint, dataSource.fetchParams || {}, DeleteTweetDocument, variables)(),
    ...options
  }
    )};

useDeleteTweetMutation.getKey = () => ['DeleteTweet'];

export const GetForYouFeedDocument = /*#__PURE__*/ `
    query GetForYouFeed($userId: ID, $interests: [String!], $first: Int, $after: String) {
  forYouFeed(userId: $userId, interests: $interests, first: $first, after: $after) {
    edges {
      node {
        id
        content
        contentType
        mediaUrls
        category
        hashtags
        createdAt
        author {
          id
          username
          displayName
          avatarUrl
          isVerified
        }
        engagement {
          likes
          comments
          shares
          views
        }
        viewerHasLiked
        viewerHasShared
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
  }
}
    `;

export const useGetForYouFeedQuery = <
      TData = GetForYouFeedQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables?: GetForYouFeedQueryVariables,
      options?: Omit<UseQueryOptions<GetForYouFeedQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetForYouFeedQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetForYouFeedQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetForYouFeed'] : ['GetForYouFeed', variables],
    queryFn: fetcher<GetForYouFeedQuery, GetForYouFeedQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, GetForYouFeedDocument, variables),
    ...options
  }
    )};

useGetForYouFeedQuery.document = GetForYouFeedDocument;

useGetForYouFeedQuery.getKey = (variables?: GetForYouFeedQueryVariables) => variables === undefined ? ['GetForYouFeed'] : ['GetForYouFeed', variables];

export const useInfiniteGetForYouFeedQuery = <
      TData = InfiniteData<GetForYouFeedQuery>,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables: GetForYouFeedQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetForYouFeedQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetForYouFeedQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetForYouFeedQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['GetForYouFeed.infinite'] : ['GetForYouFeed.infinite', variables],
      queryFn: (metaData) => fetcher<GetForYouFeedQuery, GetForYouFeedQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, GetForYouFeedDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetForYouFeedQuery.getKey = (variables?: GetForYouFeedQueryVariables) => variables === undefined ? ['GetForYouFeed.infinite'] : ['GetForYouFeed.infinite', variables];

export const GetFollowingFeedDocument = /*#__PURE__*/ `
    query GetFollowingFeed($userId: ID!, $followingIds: [ID!]!, $first: Int, $after: String) {
  followingFeed(
    userId: $userId
    followingIds: $followingIds
    first: $first
    after: $after
  ) {
    edges {
      node {
        id
        content
        author {
          id
          username
          displayName
          avatarUrl
        }
        engagement {
          likes
          comments
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

export const useGetFollowingFeedQuery = <
      TData = GetFollowingFeedQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables: GetFollowingFeedQueryVariables,
      options?: Omit<UseQueryOptions<GetFollowingFeedQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetFollowingFeedQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetFollowingFeedQuery, TError, TData>(
      {
    queryKey: ['GetFollowingFeed', variables],
    queryFn: fetcher<GetFollowingFeedQuery, GetFollowingFeedQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, GetFollowingFeedDocument, variables),
    ...options
  }
    )};

useGetFollowingFeedQuery.document = GetFollowingFeedDocument;

useGetFollowingFeedQuery.getKey = (variables: GetFollowingFeedQueryVariables) => ['GetFollowingFeed', variables];

export const useInfiniteGetFollowingFeedQuery = <
      TData = InfiniteData<GetFollowingFeedQuery>,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables: GetFollowingFeedQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetFollowingFeedQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetFollowingFeedQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetFollowingFeedQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetFollowingFeed.infinite', variables],
      queryFn: (metaData) => fetcher<GetFollowingFeedQuery, GetFollowingFeedQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, GetFollowingFeedDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetFollowingFeedQuery.getKey = (variables: GetFollowingFeedQueryVariables) => ['GetFollowingFeed.infinite', variables];

export const GetUserTweetsDocument = /*#__PURE__*/ `
    query GetUserTweets($userId: ID!, $first: Int, $after: String) {
  userTweets(userId: $userId, first: $first, after: $after) {
    edges {
      node {
        id
        body
        mediaUrls
        hashtags
        mentions
        createdAt
        updatedAt
        authorId
        authorName
        authorUsername
        authorProfileImageUrl
        isRetweet
        visibility
        status
      }
      cursor
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;

export const useGetUserTweetsQuery = <
      TData = GetUserTweetsQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables: GetUserTweetsQueryVariables,
      options?: Omit<UseQueryOptions<GetUserTweetsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUserTweetsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetUserTweetsQuery, TError, TData>(
      {
    queryKey: ['GetUserTweets', variables],
    queryFn: fetcher<GetUserTweetsQuery, GetUserTweetsQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, GetUserTweetsDocument, variables),
    ...options
  }
    )};

useGetUserTweetsQuery.document = GetUserTweetsDocument;

useGetUserTweetsQuery.getKey = (variables: GetUserTweetsQueryVariables) => ['GetUserTweets', variables];

export const useInfiniteGetUserTweetsQuery = <
      TData = InfiniteData<GetUserTweetsQuery>,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables: GetUserTweetsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetUserTweetsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetUserTweetsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetUserTweetsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetUserTweets.infinite', variables],
      queryFn: (metaData) => fetcher<GetUserTweetsQuery, GetUserTweetsQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, GetUserTweetsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetUserTweetsQuery.getKey = (variables: GetUserTweetsQueryVariables) => ['GetUserTweets.infinite', variables];

export const GetFeedItemDocument = /*#__PURE__*/ `
    query GetFeedItem($id: ID!) {
  feedItem(id: $id) {
    id
    content
    contentType
    mediaUrls
    category
    hashtags
    createdAt
    updatedAt
    author {
      id
      username
      displayName
      avatarUrl
      isVerified
    }
    engagement {
      likes
      comments
      shares
      views
      retweets
      replies
      quotes
    }
    viewerHasLiked
    viewerHasShared
    viewerCanEdit
    viewerCanDelete
  }
}
    `;

export const useGetFeedItemQuery = <
      TData = GetFeedItemQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables: GetFeedItemQueryVariables,
      options?: Omit<UseQueryOptions<GetFeedItemQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetFeedItemQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetFeedItemQuery, TError, TData>(
      {
    queryKey: ['GetFeedItem', variables],
    queryFn: fetcher<GetFeedItemQuery, GetFeedItemQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, GetFeedItemDocument, variables),
    ...options
  }
    )};

useGetFeedItemQuery.document = GetFeedItemDocument;

useGetFeedItemQuery.getKey = (variables: GetFeedItemQueryVariables) => ['GetFeedItem', variables];

export const useInfiniteGetFeedItemQuery = <
      TData = InfiniteData<GetFeedItemQuery>,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables: GetFeedItemQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetFeedItemQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetFeedItemQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetFeedItemQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetFeedItem.infinite', variables],
      queryFn: (metaData) => fetcher<GetFeedItemQuery, GetFeedItemQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, GetFeedItemDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetFeedItemQuery.getKey = (variables: GetFeedItemQueryVariables) => ['GetFeedItem.infinite', variables];

export const GetRepliesDocument = /*#__PURE__*/ `
    query GetReplies($parentId: ID!, $first: Int, $after: String) {
  replies(parentId: $parentId, first: $first, after: $after) {
    edges {
      node {
        id
        content
        contentType
        mediaUrls
        hashtags
        createdAt
        updatedAt
        author {
          id
          username
          displayName
          avatarUrl
          isVerified
        }
        engagement {
          likes
          comments
          shares
          views
        }
        viewerHasLiked
        viewerHasShared
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
  }
}
    `;

export const useGetRepliesQuery = <
      TData = GetRepliesQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables: GetRepliesQueryVariables,
      options?: Omit<UseQueryOptions<GetRepliesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetRepliesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetRepliesQuery, TError, TData>(
      {
    queryKey: ['GetReplies', variables],
    queryFn: fetcher<GetRepliesQuery, GetRepliesQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, GetRepliesDocument, variables),
    ...options
  }
    )};

useGetRepliesQuery.document = GetRepliesDocument;

useGetRepliesQuery.getKey = (variables: GetRepliesQueryVariables) => ['GetReplies', variables];

export const useInfiniteGetRepliesQuery = <
      TData = InfiniteData<GetRepliesQuery>,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables: GetRepliesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetRepliesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetRepliesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetRepliesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetReplies.infinite', variables],
      queryFn: (metaData) => fetcher<GetRepliesQuery, GetRepliesQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, GetRepliesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetRepliesQuery.getKey = (variables: GetRepliesQueryVariables) => ['GetReplies.infinite', variables];

export const CreatePostDocument = /*#__PURE__*/ `
    mutation CreatePost($input: CreatePostInput!) {
  createPost(input: $input) {
    feedItem {
      id
      content
      author {
        id
        username
      }
    }
    feedEdge {
      node {
        id
      }
      cursor
    }
    clientMutationId
  }
}
    `;

export const useCreatePostMutation = <
      TError = unknown,
      TContext = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      options?: UseMutationOptions<CreatePostMutation, TError, CreatePostMutationVariables, TContext>
    ) => {
    
    return useMutation<CreatePostMutation, TError, CreatePostMutationVariables, TContext>(
      {
    mutationKey: ['CreatePost'],
    mutationFn: (variables?: CreatePostMutationVariables) => fetcher<CreatePostMutation, CreatePostMutationVariables>(dataSource.endpoint, dataSource.fetchParams || {}, CreatePostDocument, variables)(),
    ...options
  }
    )};

useCreatePostMutation.getKey = () => ['CreatePost'];

export const ToggleLikeDocument = /*#__PURE__*/ `
    mutation ToggleLike($input: ToggleLikeInput!) {
  toggleLike(input: $input) {
    feedItem {
      id
      engagement {
        likes
      }
      viewerHasLiked
    }
    clientMutationId
  }
}
    `;

export const useToggleLikeMutation = <
      TError = unknown,
      TContext = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      options?: UseMutationOptions<ToggleLikeMutation, TError, ToggleLikeMutationVariables, TContext>
    ) => {
    
    return useMutation<ToggleLikeMutation, TError, ToggleLikeMutationVariables, TContext>(
      {
    mutationKey: ['ToggleLike'],
    mutationFn: (variables?: ToggleLikeMutationVariables) => fetcher<ToggleLikeMutation, ToggleLikeMutationVariables>(dataSource.endpoint, dataSource.fetchParams || {}, ToggleLikeDocument, variables)(),
    ...options
  }
    )};

useToggleLikeMutation.getKey = () => ['ToggleLike'];

export const AddCommentDocument = /*#__PURE__*/ `
    mutation AddComment($input: AddCommentInput!) {
  addComment(input: $input) {
    feedItem {
      id
      engagement {
        comments
      }
    }
    comment {
      id
      content
      author {
        id
        username
        displayName
        avatarUrl
      }
      createdAt
    }
    clientMutationId
  }
}
    `;

export const useAddCommentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      options?: UseMutationOptions<AddCommentMutation, TError, AddCommentMutationVariables, TContext>
    ) => {
    
    return useMutation<AddCommentMutation, TError, AddCommentMutationVariables, TContext>(
      {
    mutationKey: ['AddComment'],
    mutationFn: (variables?: AddCommentMutationVariables) => fetcher<AddCommentMutation, AddCommentMutationVariables>(dataSource.endpoint, dataSource.fetchParams || {}, AddCommentDocument, variables)(),
    ...options
  }
    )};

useAddCommentMutation.getKey = () => ['AddComment'];

export const SharePostDocument = /*#__PURE__*/ `
    mutation SharePost($input: SharePostInput!) {
  sharePost(input: $input) {
    feedItem {
      id
      engagement {
        shares
      }
    }
    sharedPost {
      id
      content
      author {
        username
      }
    }
    clientMutationId
  }
}
    `;

export const useSharePostMutation = <
      TError = unknown,
      TContext = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      options?: UseMutationOptions<SharePostMutation, TError, SharePostMutationVariables, TContext>
    ) => {
    
    return useMutation<SharePostMutation, TError, SharePostMutationVariables, TContext>(
      {
    mutationKey: ['SharePost'],
    mutationFn: (variables?: SharePostMutationVariables) => fetcher<SharePostMutation, SharePostMutationVariables>(dataSource.endpoint, dataSource.fetchParams || {}, SharePostDocument, variables)(),
    ...options
  }
    )};

useSharePostMutation.getKey = () => ['SharePost'];
